import { gql } from "@apollo/client";

export const CREATE_QUIZ_SESSION = gql`
  mutation CreateQuizSession($data: QuizSessionCreateInput!) {
    createQuizSession(data: $data) {
      id
      quizConfigurationId
      nickname
      startTime
      currentQuestionIndex
      totalQuestionsCount
      answeredQuestionsCount
    }
  }
`;

export const UPDATE_QUIZ_SESSION = gql`
  mutation UpdateQuizSession($data: QuizSessionUpdateInput!) {
    updateQuizSession(data: $data) {
      id
      currentQuestionIndex
      answeredQuestionsCount
      lastActivityTime
    }
  }
`;

export const COMPLETE_QUIZ_SESSION = gql`
  mutation CompleteQuizSession($sessionId: String!) {
    completeQuizSession(sessionId: $sessionId) {
      id
      isCompleted
      lastActivityTime
    }
  }
`;
